export const SELECTED_ORGANISATION_ID = "selectedOrganisationId";
export const SELECTED_SERVICE_ID = "selectedClientServiceId";
export const SELECTED_CATEGORIES_IDS = "selectedCategoriesIds";
